import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_general_send_line",
  "use": "icon-icon_general_send_line-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"icon-icon_general_send_line\">\n<path d=\"M41,24L9,9l5.2,15L9,39L41,24z M12.4,12.8L34.2,23H15.9L12.4,12.8z M15.9,25h18.2L12.4,35.2L15.9,25z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol